const state = {
  wizardStep: 0,
  selectedCategory: null,
  selectedSubcategory: null,
  selectedAssets: [],
  issueDescription: null,
};

const getters = {
  wizardStep: (state) => state.wizardStep,
  selectedCategory: (state) => state.selectedCategory,
  selectedSubcategory: (state) => state.selectedSubcategory,
  selectedAssets: (state) => state.selectedAssets,
  issueDescription: (state) => state.issueDescription,
};

const actions = {
  async reset() {
    state.wizardStep = 0;
    state.selectedCategory = null;
    state.selectedSubcategory = null;
    state.selectedAssets = [];
    state.issueDescription = null;
  },
  async setWizardStep({ commit }, wizardStep) {
    commit('wizardStepSet', wizardStep);
  },
  async setSelectedCategory({ commit }, category) {
    commit('selectedCategorySet', category);
  },
  async setSelectedSubcategory({ commit }, subcategory) {
    commit('selectedSubcategorySet', subcategory);
  },
  async setSelectedAssets({ commit }, assets) {
    commit('selectedAssetsSet', assets);
  },
  async setIssueDescription({ commit }, issueDescription) {
    commit('issueDescriptionSet', issueDescription);
  },
};

const mutations = {
  wizardStepSet(state, wizardStep) {
    console.log('wizardStepSet', wizardStep);
    state.wizardStep = wizardStep;
  },
  selectedCategorySet(state, category) {
    console.log('selectedCategorySet', category);
    state.selectedCategory = category;
  },
  selectedSubcategorySet(state, subcategory) {
    console.log('selectedSubcategorySet', subcategory);
    state.selectedSubcategory = subcategory;
  },
  selectedAssetsSet(state, assets) {
    console.log('selectedAssetsSet', assets);
    state.selectedAssets = assets;
  },
  issueDescriptionSet(state, issueDescription) {
    state.issueDescription = issueDescription;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
